import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e301d45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "road-event-list-container" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "교통정보",
      shouldHideBackButton: true,
      onOnClickClose: $setup.emitOnClickClose
    }),
    _createElementVNode("ul", {
      ref: "contentWrapper",
      class: "content-wrapper",
      role: "list",
      "aria-label": "교통정보 목록",
      onScroll: $setup.handleScroll
    }, [
      ($setup.roadEventList.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.roadEventList, (roadEvent) => {
            return (_openBlock(), _createElementBlock("li", {
              key: roadEvent.uid
            }, [
              _createVNode($setup["RoadEventRow"], { roadEvent: roadEvent }, null, 8 /* PROPS */, ["roadEvent"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        : (!$setup.isLoading)
          ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
              _createVNode($setup["EmptyContent"], { text: "교통정보가 없습니다." })
            ]))
          : _createCommentVNode("v-if", true)
    ], 544 /* NEED_HYDRATION, NEED_PATCH */)
  ]))
}